export default "__VITE_ASSET__BlyK8C12__"